import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { _derivatModulDimenzije_finalneSirinaVisina } from "./ter-derivat-lib-terkk-modul";
import { js_utils } from "../utils/frfr-js-utils";
import { derivatAutoCreateVirtel_modulrogalj, derivatAutoCreateVirtel_modulrogalj_priprema_ulaza } from "./ter-derivat-lib-terkk-modul-rogalj";
import { derivatAutoCreateVirtel_modulprofil, derivatAutoCreateVirtel_modulprofilpregradniuncarr, derivatAutoCreateVirtel_modulprofil_priprema_ulaza } from "./ter-derivat-lib-terkk-modul-profil";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import tclocal from "./ter-consts-local-lib";
import { _derivat_terkk_modul_nosaci_za_klocne_limcustom_bundleDraftel_make, _derivat_terkk_modul_ukrucenje_limcustom_bundleDraftel_make } from "./ter-derivat-lib-terkk-modul-extra";
import { draftel_codecs_pack_terkk$_bundle_limcustom } from "./ter-draftel-codec-lib-terkk-bundle-limcustom";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$modul = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$modul.default_preset_state = () => {
  // const preset_state = {
  return {
    _draftelschemakey: 'terkk$modul',
    terkknivo: 'modul', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    "brojmodula": null,
    "siframodula": null,
    "nazivmodula": null,
    "duzinamodula": null,

    "kojavelicina": null,

    // "name": "displaysirinamodula",
    // "name": "displayvisinamodula",

    "sirinamodulaunc": null,
    "visinamodulaunc": null,

    // "name": "displayduzinaprofilapregradnisirinski",
    "brojkomadaprofilpregradnisirinski": null,

    // "name": "displayduzinaprofilapregradnivisinski",
    "brojkomadaprofilpregradnivisinski": null,

    /*
    //  export const definicijaModul_profilpregradniunc = [
    "name": "duzinaprofilpregradniunc",
    "name": "brojkomadaprofilpregradniunc",
    */
    "Par4": null,
    "Par5": null,

    // NOVO 2024-09-05
    "modul_vrsta_pakovanja": null,
  };
  // return preset_state;
};


draftel_codecs_pack_terkk$modul.default_pods_input_state = () => {
  /*
  return {
    vrstaprofila: null,
    flag_dvevelicine: null,
    ksirinaspoljasnja: null,
    kvisinaspoljasnja: null,
    ksirina2spoljasnja: null,
    kvisina2spoljasnja: null,
  };
  */
  return default_pods_input_state_smart_get('terkk$modul');
};


draftel_codecs_pack_terkk$modul.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "vrstaprofila",
  // "flag_dvevelicine",
  // "ksirinaspoljasnja",
  // "kvisinaspoljasnja",
  // "ksirina2spoljasnja",
  // "kvisina2spoljasnja",
  ...Object.keys(draftel_codecs_pack_terkk$modul.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  "brojmodula",
  "siframodula",
  "nazivmodula",
  "duzinamodula",
  "kojavelicina",
  "sirinamodulaunc",
  "visinamodulaunc",
  "brojkomadaprofilpregradnisirinski",
  "brojkomadaprofilpregradnivisinski",
  "bomlevel_imported",
  "Par4",
  "Par5",
  ...Object.keys(draftel_codecs_pack_terkk$modul.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


// draftel_codecs_pack_terkk$modul.drafel_to_virtel = (formState, pods_input) => { 
draftel_codecs_pack_terkk$modul.drafel_to_virtel = (formState) => { // NOVO 2023-05-03 svi pods_inputi su vec ukljuceni
  // pretvara iz formState u virtel format sa ispravnim flagovima
  /*
  */
  const sema = virtel_schema_smart_get('terkk$modul');
  console.log(formState);
  let state = {
    ...formState
  };
  console.log(state);
  state.flag_dvevelicine = false;
  state.kojavelicina = null; // ponistavamo virtel polje
  state.flag_dimenzijemodulaunc = false; // i sirina i visina su UNC. NOVO AVGUST
  state.sirinamodulaunc = null; // ponistavamo virtel polje
  state.visinamodulaunc = null; // ponistavamo virtel polje
  //
  if (formState.kojavelicina === "unc") {
    // velicina unc
    state.kojavelicina = "unc";
    state.flag_dimenzijemodulaunc = true; // i sirina i visina su UNC. NOVO AVGUST
    state.sirinamodulaunc = formState.sirinamodulaunc; // uvazavamo virtel polje
    state.visinamodulaunc = formState.visinamodulaunc; // uvazavamo virtel polje
  } else {
    // velicina 1 ili 2
    if (formState.flag_dvevelicine === true) {
      // postoje dve standardne velicine za module
      state.flag_dvevelicine = true;
    } else {
      // samo jedna standardna velcina za module
      state.flag_dvevelicine = false;
      if (formState.kojavelicina === '1') {
        // test
        console.log('test jedna velicina, odabrano 1');
      }
    }
    state.kojavelicina = formState.kojavelicina; // uvazavamo virtel polje
  }
  console.log(state);
  //
  // const m = formState;
  // const pods_input = derivat_modul_pripremi_pods_input_inherited_za_draftel(virtel_k);
  // const derivati_modula_pods_input = _derivatModulDimenzije_finalneSirinaVisina_priprema_ulaza(virtel_k, m);
  // const derivati_modula = _derivatModulDimenzije_finalneSirinaVisina(derivati_modula_pods_input);
  const pods_input = formState; // NOVO 2023-05-03
  const derivati_modula = _derivatModulDimenzije_finalneSirinaVisina(pods_input, state.kojavelicina, state.flag_dimenzijemodulaunc, state.sirinamodulaunc, state.visinamodulaunc);
  // let modulNaziv = 'Modul broj ' + p.brojmodula;
  const state2 = {
    virtelschemakey: 'terkk$modul',
    ...state,
    // ...pods_input, // ???
    // ...pods_input, // ??? Trebalo bi da mora da primi sve svoje inpute mejdu svoje podatke samo je pitanje u kojoj fazi?
    ...derivati_modula,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    multitranslator_lang: "terkk$modul/modul",
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$modul") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$modul.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$modul');
  const virtel = draftel_codecs_pack_terkk$modul.drafel_to_virtel(draftel); // pods_input su vec ukljuceni
  const m = draftel;

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // const modul_subkey = m.subkey;
  // const m_graphlevel = 2;
  // const modul_pods_input = derivat_modul_pripremi_pods_input_inherited_za_draftel(virtel_k);
  /*
  let virtel_m = {
    ...draftel_codecs_pack_terkk$modul.drafel_to_virtel(m, modul_pods_input),
  }
  */
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_m, m_graphlevel);
  // _virbom_manipulator.add_on_top_graphlevel(virbom_ref, virtel);
  _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);
  const local_graphlevel = 1;


  // KORAK poluproizvod level 3 virtel
  // SAD SE BAVIMO DERIVATIMA OD MODULA... konstrukcijom modula...

  // ROGALJ MODULA
  // KORAK pripreme derivata za rogalj
  let rogalj_pods_input = derivatAutoCreateVirtel_modulrogalj_priprema_ulaza(virtel.vrstaprofila);
  let rogalj_sect_der = derivatAutoCreateVirtel_modulrogalj(rogalj_pods_input);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, rogalj_sect_der, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // PROFILI MODULA
  /* 
  // osnovniduzinski
  let arr_modulprofili = [
    'osnovniduzinski',
    'osnovniduzinski/m',
    'osnovnivisinski',
    'osnovnivisinski/m',
    'osnovnisirinski',
    'osnovnisirinski/m',
    'pregradnisirinski',
    'pregradnisirinski/ops',
    'pregradnisirinski/m',
    'pregradnivisinski',
    'pregradnivisinski/ops',
    'pregradnivisinski/m'
  ];
  */
  //
  // KORAK pripreme derivata za profile modula
  let pods_input_za_derivate = derivatAutoCreateVirtel_modulprofil_priprema_ulaza(virtel); // ??? kako doci do p
  let _derivati = derivatAutoCreateVirtel_modulprofil(pods_input_za_derivate);
  console.log('_derivati PROFILI')
  console.log(_derivati)
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);


  // PROFILI MODULA profilpregradniunc cuustom profili pregradni
  // console.log('m');
  // console.log(m);
  const _subform_arr = m._subform_arr;
  let _derivati_profilpregradniunc = derivatAutoCreateVirtel_modulprofilpregradniuncarr(pods_input_za_derivate, _subform_arr);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati_profilpregradniunc, local_graphlevel + 1, virbomCounter.generateFreshSubkey);


  // SPECIAL EXTRA STEPS
  if (virtel.mvisinaspoljasnja > 1800) {
    //
    const _modul_ukrucenje_limcustom_bundledraftel = _derivat_terkk_modul_ukrucenje_limcustom_bundleDraftel_make();
    const _virbom_modul_ukrucenje = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom(_modul_ukrucenje_limcustom_bundledraftel);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _virbom_modul_ukrucenje, local_graphlevel + 1, virbomCounter.generateFreshSubkey);
  }
  if (virtel.modul_vrsta_pakovanja === "KLOCNA") {
    //
    const _modul_nosaci_za_klocne_limcustom_bundledraftel = _derivat_terkk_modul_nosaci_za_klocne_limcustom_bundleDraftel_make(virtel);
    const modul_nosaci_za_klocne = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom(_modul_nosaci_za_klocne_limcustom_bundledraftel);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, modul_nosaci_za_klocne, local_graphlevel + 1, virbomCounter.generateFreshSubkey);
  }


  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


//
draftel_codecs_pack_terkk$modul._special_combo_to_bundleDraftel = (virtel_m, _arr_profilpregradniunc_za_kasnije, _generate_fresh_subkey, _generateFreshTempkey) => {
  console.log('*** MODUL.virtel_to_draftel');
  console.log('_arr_profilpregradniunc_za_kasnije');
  console.log(_arr_profilpregradniunc_za_kasnije);
  // pretvara iz virtela u formState format
  //
  let _subform_arr = [];
  // kod modula nemamo bundle_id jer sam modul draftel ujedno igra ulogu bundlea za profile
  _arr_profilpregradniunc_za_kasnije.forEach(profil => {
    if (profil.parent_subkey === virtel_m.subkey) {
      _subform_arr.push({
        tempkey: _generateFreshTempkey(),
        duzinaprofilpregradniunc: profil.duzina,
        brojkomadaprofilpregradniunc: profil.kolicina,
        bomlevel_imported: profil.bomlevel_imported,
      });
    }
  });
  //
  let bundleDraftel = {
    ...draftel_codecs_pack_terkk$modul.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel_m, draftel_codecs_pack_terkk$modul.keys_for_direct_cloning)
  };
  if (bundleDraftel.flag_dimenzijemodulaunc === true) {
    bundleDraftel.kojavelicina = "unc";
  };
  bundleDraftel._subform_arr = _subform_arr;
  //
  console.log(bundleDraftel);
  return bundleDraftel; // return special modul bundleDraftel
};

